import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DetailFormDataModel } from 'src/app/config/model/detail-form-data.model';
import { ConfigService } from 'src/app/config/config.service';

@Component({
  selector: 'dms-image',
  templateUrl: './dms-image.component.html',
  styleUrls: ['./dms-image.component.scss'],
  standalone: false,
})
export class DmsImageComponent implements OnInit {
  @Input() prop: any = {};
  @Input() graphicFormGroup: UntypedFormGroup;
  @Input() detailFormDataModel: DetailFormDataModel;

  imgSource: string;

  constructor(public configService: ConfigService) {}

  ngOnInit() {
    const id = this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name];
    if (id) {
      this.imgSource = `${this.configService.dmsBaseUrl}/denkmalPflegeDMSAdapter?id=${id}`;
    }
  }
}
